import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'expiryDate',
  standalone: true
})
export class ExpiryDatePipe implements PipeTransform {
  transform(expiryDate: string, format: 'display' | 'api' = 'display'): string {
    if (!expiryDate) return '';
    
    // Remove tudo que não é número
    const numbers = expiryDate.replace(/\D/g, '');
    
    if (format === 'api') {
      // Formato para API: YYYYMM
      // Se tem 6 dígitos (MMYYYY), converte para YYYYMM
      if (numbers.length === 6) {
        const month = numbers.substring(0, 2);
        const year = numbers.substring(2, 6);
        return year + month;
      }
      
      // Se tem 4 dígitos (MMYY), converte para 20YYMM
      if (numbers.length === 4) {
        const month = numbers.substring(0, 2);
        const year = '20' + numbers.substring(2, 4);
        return year + month;
      }
      
      return numbers;
    } else {
      // Formato para exibição: MM/YYYY
      if (numbers.length <= 2) {
        return numbers;
      } else if (numbers.length <= 6) {
        return numbers.substring(0, 2) + '/' + numbers.substring(2, 6);
      } else {
        return numbers.substring(0, 2) + '/' + numbers.substring(2, 6);
      }
    }
  }
}
